export const categoryArticles = {
  'wanghong-tafang': {
    title: '网红塌房',
    description: '网红人设崩塌、翻车现场实时追踪，一手爆料不停',
    articles: [
      {
        id: 'wt-1',
        slug: 'dingri-jinjing-tafang',
        title: '顶流网红直播翻车，人设崩塌现场全记录',
        excerpt: '某千万粉丝顶流网红在直播中意外暴露真实面目，前后人设反差巨大……',
        date: '2026-07-06',
        views: 128000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Shocked%20internet%20celebrity%20live%20streaming%20accident%20moment%2C%20dramatic%20lighting%20with%20warm%20and%20dark%20contrast%2C%20cinematic%20photography%20style%2C%20emotional%20expression%2C%20soft%20bokeh%20background%20with%20modern%20studio%20setting&width=800&height=1067&seq=cat-wt-01&orientation=portrait',
      },
      {
        id: 'wt-2',
        slug: 'duanzi-shou-mimi-jiehun',
        title: '某知名短剧博主被曝秘密结婚，粉丝集体脱粉',
        excerpt: '粉丝发现细节线索，顺藤摸瓜挖出隐婚实锤……',
        date: '2026-07-07',
        views: 67000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Secret%20wedding%20scandal%20concept%2C%20dramatic%20reveal%20moment%20with%20wedding%20ring%20focus%2C%20warm%20intimate%20lighting%20with%20soft%20shadows%2C%20emotional%20atmosphere&width=800&height=1067&seq=cat-wt-02&orientation=portrait',
      },
      {
        id: 'wt-3',
        slug: 'yundong-bozhu-zuobi',
        title: '健身博主被指使用药物，科学分析揭秘真相',
        excerpt: '专业人士从训练痕迹、肌肉形态等角度深度分析……',
        date: '2026-07-04',
        views: 38000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Fitness%20influencer%20controversy%20concept%2C%20gym%20setting%20with%20dramatic%20contrast%20lighting%2C%20athletic%20atmosphere%20with%20warm%20tones&width=800&height=1067&seq=cat-wt-03&orientation=portrait',
      },
      {
        id: 'wt-4',
        slug: 'meishi-bozhu-dianpu',
        title: '美食博主推荐的餐厅被曝卫生问题严重',
        excerpt: '探店博主力推的网红餐厅后厨触目惊心……',
        date: '2026-07-02',
        views: 45000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Dirty%20restaurant%20kitchen%20scandal%2C%20food%20safety%20violation%20concept%2C%20dark%20dramatic%20lighting%20with%20warm%20tones%2C%20documentary%20photography%20style&width=800&height=1067&seq=cat-wt-04&orientation=portrait',
      },
      {
        id: 'wt-5',
        slug: 'luxing-bozhu-zhaopian',
        title: '旅行博主被扒盗用他人照片，人设全线崩塌',
        excerpt: '细心网友发现博主"旅行照"多处PS痕迹……',
        date: '2026-06-30',
        views: 56000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Travel%20photo%20theft%20scandal%20concept%2C%20fake%20travel%20photography%20exposed%2C%20dramatic%20lighting%20with%20warm%20amber%20tones%2C%20editorial%20investigation%20style&width=800&height=1067&seq=cat-wt-05&orientation=portrait',
      },
      {
        id: 'wt-6',
        slug: 'chongwu-bozhu-nuedai',
        title: '宠物博主被指虐待动物，动物保护组织介入调查',
        excerpt: '视频中的"可爱瞬间"实为虐待证据……',
        date: '2026-06-28',
        views: 72000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Animal%20welfare%20controversy%20concept%2C%20pet%20care%20scandal%2C%20emotional%20dramatic%20lighting%20with%20warm%20and%20dark%20contrast&width=800&height=1067&seq=cat-wt-06&orientation=portrait',
      },
    ],
  },
  'xuanxiu-heimu': {
    title: '选秀黑幕',
    description: '综艺选秀节目背后的故事，内幕大揭秘',
    articles: [
      {
        id: 'xh-1',
        slug: 'xuanxiu-jimu-heiliao',
        title: '选秀节目黑幕大揭秘：导师暗箱操作实锤',
        excerpt: '知情人士曝光某选秀节目内幕，导师提前内定晋级名额……',
        date: '2026-07-05',
        views: 96000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20backstage%20dramatic%20moment%2C%20contestant%20emotional%20breakdown%20under%20stage%20lights%2C%20dark%20atmosphere%20with%20spotlight%20contrast&width=800&height=1067&seq=cat-xh-01&orientation=portrait',
      },
      {
        id: 'xh-2',
        slug: 'yinyue-ren-jiechou',
        title: '知名音乐人被扒抄袭，多首热门歌曲涉嫌侵权',
        excerpt: '网友逐帧对比扒谱，证据链完整令人震惊……',
        date: '2026-07-05',
        views: 43000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Music%20plagiarism%20controversy%20concept%2C%20sheet%20music%20comparison%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere&width=800&height=1067&seq=cat-xh-02&orientation=portrait',
      },
      {
        id: 'xh-3',
        slug: 'wudao-jingxuan-neimu',
        title: '舞蹈竞技节目评分黑幕，评委私下收受好处',
        excerpt: '匿名工作人员爆料节目组操控评分系统……',
        date: '2026-07-01',
        views: 51000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Dance%20competition%20scoring%20scandal%2C%20judges%20controversy%2C%20dramatic%20stage%20lighting%20with%20warm%20golden%20tones&width=800&height=1067&seq=cat-xh-03&orientation=portrait',
      },
      {
        id: 'xh-4',
        slug: 'geshou-jiayin-chang',
        title: '某知名歌手被质疑假唱，技术分析视频全网疯传',
        excerpt: '音频工程师逐帧分析演唱会现场音轨……',
        date: '2026-06-29',
        views: 89000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Lip%20syncing%20controversy%20at%20concert%2C%20singer%20on%20stage%20with%20dramatic%20spotlight%2C%20warm%20theatrical%20lighting&width=800&height=1067&seq=cat-xh-04&orientation=portrait',
      },
    ],
  },
  'zongyi-fanche': {
    title: '综艺翻车',
    description: '综艺节目尴尬名场面，翻车现场直击',
    articles: [
      {
        id: 'zf-1',
        slug: 'yishujia-zhaopian',
        title: '某艺术家被指作品全是AI生成，收藏圈地震',
        excerpt: '数字艺术圈惊爆丑闻，数千万交易额恐成泡沫……',
        date: '2026-07-02',
        views: 29000,
        imageUrl: 'https://readdy.ai/api/search-image?query=AI%20art%20controversy%20scandal%20concept%2C%20digital%20art%20display%20with%20dramatic%20gallery%20lighting%2C%20futuristic%20yet%20dark%20moody%20atmosphere&width=800&height=1067&seq=cat-zf-01&orientation=portrait',
      },
      {
        id: 'zf-2',
        slug: 'zongyi-jiemu-juben',
        title: '综艺剧本曝光：参与者全程照剧本演',
        excerpt: '内部人员泄露综艺节目完整剧本，观众震惊……',
        date: '2026-06-27',
        views: 63000,
        imageUrl: 'https://readdy.ai/api/search-image?query=TV%20show%20script%20leak%20scandal%2C%20dramatic%20backstage%20moment%2C%20dark%20cinematic%20lighting%20with%20warm%20accents&width=800&height=1067&seq=cat-zf-02&orientation=portrait',
      },
      {
        id: 'zf-3',
        slug: 'zhuchiren-shikong',
        title: '主持人在直播中失言，节目组紧急公关',
        excerpt: '某主持人脱口而出的言论引发轩然大波……',
        date: '2026-06-25',
        views: 78000,
        imageUrl: 'https://readdy.ai/api/search-image?query=TV%20host%20controversy%20during%20live%20show%2C%20awkward%20studio%20moment%2C%20dramatic%20broadcast%20lighting%20with%20warm%20tones&width=800&height=1067&seq=cat-zf-03&orientation=portrait',
      },
    ],
  },
  'zhibo-baoliao': {
    title: '直播爆料',
    description: '直播间里的精彩瞬间，爆料不断',
    articles: [
      {
        id: 'zb-1',
        slug: 'zhibo-daihuo-jiahuo',
        title: '知名主播带货翻车，假货风波持续发酵',
        excerpt: '消费者集体投诉某大主播售卖假冒伪劣产品……',
        date: '2026-07-04',
        views: 85000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20shopping%20scandal%20moment%2C%20influencer%20holding%20product%20with%20shocked%20expression%2C%20dramatic%20studio%20lighting&width=800&height=1067&seq=cat-zb-01&orientation=portrait',
      },
      {
        id: 'zb-2',
        slug: 'meizhuang-bozhu-choushi',
        title: '美妆博主素颜出镜惊呆众人，前后差距引争议',
        excerpt: '百万粉丝美妆博主力证"化妆如换头"……',
        date: '2026-07-06',
        views: 54000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Beauty%20influencer%20before%20and%20after%20makeup%20comparison%2C%20dramatic%20transformation%20concept%2C%20soft%20natural%20lighting&width=800&height=1067&seq=cat-zb-02&orientation=portrait',
      },
      {
        id: 'zb-3',
        slug: 'zhibozhu-shuijue',
        title: '主播直播中睡着引百万人围观，醒来反应绝了',
        excerpt: '熬夜直播的主播意外睡着，直播间人气不降反升……',
        date: '2026-07-03',
        views: 32000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Streamer%20falling%20asleep%20during%20live%20broadcast%2C%20funny%20unexpected%20moment%2C%20dim%20warm%20room%20lighting&width=800&height=1067&seq=cat-zb-03&orientation=portrait',
      },
      {
        id: 'zb-4',
        slug: 'youxi-zhubo-kaoguazai',
        title: '游戏主播代打被实锤，摄像头意外暴露真相',
        excerpt: '直播画面一角的反光镜暴露了惊人真相……',
        date: '2026-06-26',
        views: 61000,
        imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20streamer%20cheating%20scandal%2C%20reflection%20reveal%20moment%2C%20dark%20room%20with%20monitor%20glow%20lighting&width=800&height=1067&seq=cat-zb-04&orientation=portrait',
      },
    ],
  },
};

export const categoryReviews = [
  {
    id: 'cr-1',
    name: '暴躁吃瓜',
    role: '忠实读者',
    text: '网红塌房区的爆料太猛了，每天不看睡不着觉！',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20excited%20portrait%2C%20casual%20style%2C%20warm%20lighting%2C%20enthusiastic%20expression%2C%20clean%20background&width=120&height=120&seq=cat-review-01&orientation=squarish',
    imageUrl: '',
    isImageCard: false,
  },
  {
    id: 'cr-2',
    name: '真相挖掘机',
    role: '资深用户',
    text: '这里的爆料有深度有态度，不是单纯煽风点火。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20portrait%2C%20serious%20expression%2C%20warm%20indoor%20lighting%2C%20clean%20background&width=120&height=120&seq=cat-review-02&orientation=squarish',
    imageUrl: '',
    isImageCard: false,
  },
  {
    id: 'cr-3',
    name: '深夜吃瓜人',
    role: '夜猫子用户',
    text: '',
    avatar: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20reading%20phone%20at%20night%2C%20cozy%20dark%20room%20with%20warm%20screen%20glow%2C%20dramatic%20blue%20hour%20lighting%2C%20lifestyle%20photography&width=600&height=800&seq=cat-review-img-01&orientation=portrait',
    isImageCard: true,
  },
  {
    id: 'cr-4',
    name: '理性分析君',
    role: '社区达人',
    text: '每天来这里看最新爆料，比刷短视频有意思多了。',
    avatar: 'https://readdy.ai/api/search-image?query=Thoughtful%20Chinese%20young%20adult%20portrait%2C%20warm%20natural%20lighting%2C%20clean%20background%2C%20casual%20professional%20look&width=120&height=120&seq=cat-review-04&orientation=squarish',
    imageUrl: '',
    isImageCard: false,
  },
  {
    id: 'cr-5',
    name: '追瓜第一线',
    role: '一线吃瓜群众',
    text: '点赞！爆料速度全网最快，吃瓜绝不落后。',
    avatar: 'https://readdy.ai/api/search-image?query=Excited%20Chinese%20young%20woman%20portrait%2C%20warm%20outdoor%20lighting%2C%20enthusiastic%20expression%2C%20casual%20style&width=120&height=120&seq=cat-review-05&orientation=squarish',
    imageUrl: '',
    isImageCard: false,
  },
];